import { render, staticRenderFns } from "./Maintenance-Documents.vue?vue&type=template&id=fd88dcb4&"
import script from "./Maintenance-Documents.vue?vue&type=script&lang=ts&"
export * from "./Maintenance-Documents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports